import { Types } from "@grandvisionhq/graphql";
import { convertToValidOpeningHours } from "../../../../../../pages/adapters/pages/adapters/convert-to-valid-opening-hours.js";
import { FRANCHISE_STORE } from "../../../../../../types.js";
const mapStoreResult = (item) => {
  const inventory = "inventory" in item ? item.inventory : void 0;
  const productReservability = "productReservability" in item ? item.productReservability : void 0;
  const appointmentTypes = "appointmentTypes" in item ? item.appointmentTypes : void 0;
  const storeOffers = "offers" in item ? item.offers : void 0;
  const storeTypes = item.storeTypes || [];
  return {
    code: item.code,
    globalStoreId: item.globalStoreId,
    name: item.name,
    shortName: item.shortName,
    streetName: item.streetName,
    town: item.town,
    country: item.country,
    phone: item.phone,
    slug: item.slug ?? void 0,
    storeNote: item.storenote ?? void 0,
    streetNumber: item.streetNumber ?? void 0,
    additionalStreetInfo: item.additionalStreetInfo ?? void 0,
    postalCode: item.postalCode ?? void 0,
    province: item.province ?? void 0,
    lat: item.lat ?? void 0,
    lon: item.lon ?? void 0,
    emailAddress: item.email ?? void 0,
    distance: item.distance,
    servicesNotAvailable: item.servicesNotAvailable ?? [],
    openingHours: {
      monday: convertToValidOpeningHours(item.monOpenClose),
      tuesday: convertToValidOpeningHours(item.tueOpenClose),
      wednesday: convertToValidOpeningHours(item.wedOpenClose),
      thursday: convertToValidOpeningHours(item.thuOpenClose),
      friday: convertToValidOpeningHours(item.friOpenClose),
      saturday: convertToValidOpeningHours(item.satOpenClose),
      sunday: convertToValidOpeningHours(item.sunOpenClose)
    },
    specialOpeningHours: (item.specialOpenClosingHours ?? []).filter(
      (x) => x !== null
    ),
    wheelchairAccessible: item.wheelchairAccessible ?? false,
    hearingAppointmentPossible: item.hearingAppointmentPossible ?? false,
    weekendOpen: item.weekendOpen ?? false,
    stock: inventory ? {
      status: inventory.stockIndicator,
      quantity: inventory.totalQuantity ?? void 0,
      showroomModelAvailable: inventory.items.some((x) => x.showroomModelAvailable)
    } : void 0,
    inStoreReservable: productReservability?.inStoreReservable ?? false,
    appointmentTypes: appointmentTypes?.map((appointmentType) => ({
      id: appointmentType.id,
      isAvailableInStore: appointmentType.isAvailableInStore
    })),
    offers: storeOffers,
    isFranchiseStore: storeTypes.includes(FRANCHISE_STORE),
    appointmentsAvailable: item.appointmentsAvailable,
    filterServicesNotAvailableAppointmentsStore: item.servicesNotAvailable?.includes(Types.ServicesNotAvailable.APPOINTMENTS) ?? false
  };
};
const mapStoresResult = (storeSearchQueryData, shouldFilterServicesNotAvailableAppointmentsAtStore) => {
  if (!storeSearchQueryData) {
    return null;
  }
  try {
    let stores = storeSearchQueryData.map(mapStoreResult);
    if (shouldFilterServicesNotAvailableAppointmentsAtStore) {
      stores = stores.filter((store) => !store.filterServicesNotAvailableAppointmentsStore);
    }
    return stores;
  } catch (e) {
    console.error(
      "Store search query data adapter failed to parse input data correctly.",
      e,
      storeSearchQueryData
    );
    return null;
  }
};
export {
  mapStoresResult as default,
  mapStoreResult,
  mapStoresResult
};
//# sourceMappingURL=mapStoresResult.js.map
